import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.number.constructor";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { API_REQUEST } from '@/api';
import Vue from 'vue';
import { deepClone } from '@/modules/mm-utils';
import { getUniversalMutations, getUniversalGetters } from '@/common/store';
import { formEmployment, formWorkTypesFromRequest, saveEmploymentMainInfo, saveEmploymentConstraints, saveWorkTypesForEmployment } from '@/modules/staff/employments';
import { getIndexedCollection, filterByUniqueField, lens } from '@/common/helpers';
var R_T = {
  root: true
};
/**
 * @returns {import('./staff').StaffState}
 */

var state = function state() {
  return {
    users: [],
    shiftSchedule: {},
    fetchedShifts: {},
    employees: [],
    employments: [],
    departments: [],
    departmentsIncludeClients: [],
    departmentsIncludeOutsources: [],
    departmentsIncludePossibleClients: [],
    workTypes: [],
    positions: [],
    networks: [],
    medicalDocumentTypes: [],
    medicalDocuments: []
  };
};

var mutations = _objectSpread(_objectSpread({}, getUniversalMutations(state())), {}, {
  setUsers: function setUsers(state, _ref) {
    var users = _ref.users;
    state.users = users;
  },
  setEmployees: function setEmployees(state, _ref2) {
    var employees = _ref2.employees;
    state.employees = employees;
  },
  setEmployments: function setEmployments(state, employments) {
    state.employments = employments;
  },
  setUserInfo: function setUserInfo(state, _ref3) {
    var id = _ref3.id,
        userInfo = _ref3.userInfo;
    var userIndex = state.users.findIndex(function (user) {
      return String(user.user_id) === String(id);
    });

    if (userIndex !== -1) {
      var newUserObj = Object.assign({}, state.users[userIndex], deepClone(userInfo));
      Vue.set(state.users, userIndex, newUserObj);
    }
  },
  setShiftSchedule: function setShiftSchedule(state, newValue) {
    state.shiftSchedule = newValue;
  },
  addFetchedShift: function addFetchedShift(state, _ref4) {
    var employeeId = _ref4.employeeId,
        dateStart = _ref4.dateStart,
        dateEnd = _ref4.dateEnd;
    var key = "".concat(employeeId, "-").concat(dateStart, "-").concat(dateEnd);
    state.fetchedShifts[key] = true;
  },
  resetFetchedShift: function resetFetchedShift(state) {
    state.fetchedShifts = {};
  }
});

var actions = {
  /**
   * @deprecated
   */
  getEmploymentsForUsers: function getEmploymentsForUsers(_ref5, employments) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dispatch, depsById, workTypes, positions, employmentsByUserId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref5.dispatch;
              _context.next = 3;
              return dispatch('cachedData/getAllDepartments', {
                byId: true
              }, R_T);

            case 3:
              depsById = _context.sent;
              _context.next = 6;
              return dispatch('cachedData/getWorkTypes', {}, R_T);

            case 6:
              workTypes = _context.sent;
              _context.next = 9;
              return dispatch('cachedData/getAllWorkerPositions', {}, R_T);

            case 9:
              positions = _context.sent;
              employmentsByUserId = employments.reduce(function (accumulator, empl) {
                var _positions$find;

                var emplUserId = empl['employee_id'];
                if (!accumulator[emplUserId]) accumulator[emplUserId] = [];
                delete empl['user'];
                empl['_dep_title'] = depsById[empl['shop_id']] ? depsById[empl['shop_id']].name : '';
                empl['_work_type_ids'] = empl['work_types'].map(function (wt) {
                  return wt['work_type_id'];
                });
                empl['_work_types'] = empl['work_types'].map(function (workType) {
                  var wType = workTypes.find(function (wt) {
                    return wt.id === workType['work_type_id'];
                  });
                  var workTypeLabel = wType && wType.label || '';
                  return {
                    id: workType['work_type_id'],
                    label: workTypeLabel
                  };
                });
                empl['_week_availability'] = empl['week_availability'] === 7 ? 'd7' : 'd0';
                empl['_work_types_by_id'] = workTypes.reduce(function (acc, workType) {
                  var found = empl['work_types'].find(function (wt) {
                    return wt['work_type_id'] === workType.id;
                  });
                  acc[workType.id] = Object.assign({}, workType, {
                    state: found ? found.priority : null,
                    absId: found ? found.id : null
                  });
                  return acc;
                }, {});
                empl['_worker_constraints'] = empl['worker_constraints'];
                delete empl['worker_constraints'];
                empl['_position_title'] = empl['position_id'] ? ((_positions$find = positions.find(function (position) {
                  return position.id === empl['position_id'];
                })) === null || _positions$find === void 0 ? void 0 : _positions$find.name) || '' : '';
                empl['_expansion_label'] = empl['_dep_title'];
                var depInfo = depsById[empl['shop_id']];
                empl['_dep_start_time'] = depInfo ? depInfo['tm_shop_opens'] : '';
                empl['_dep_end_time'] = depInfo ? depInfo['tm_shop_closes'] : '';
                empl['_dep_time_gap'] = depInfo ? depInfo['forecast_step_minutes'] : '';
                var dep = depsById[empl['shop_id']];
                var openCloseTimes = {};

                if (dep) {
                  if (dep['tm_open_dict'].all) {
                    var weekNumber = new Array(7).fill(0);
                    weekNumber.forEach(function (_, week) {
                      openCloseTimes[week] = {
                        start: dep['tm_open_dict'].all,
                        end: dep['tm_close_dict'].all
                      };
                    });
                  } else {
                    Object.keys(dep['tm_open_dict']).forEach(function (week) {
                      openCloseTimes[week] = {
                        start: dep['tm_open_dict'][week],
                        end: dep['tm_close_dict'][week]
                      };
                    });
                  }
                }

                empl['_open_close_tms'] = openCloseTimes;
                accumulator[emplUserId].push(empl);
                return accumulator;
              }, {});
              return _context.abrupt("return", employmentsByUserId);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getUserInfo: function getUserInfo(_ref6, _ref7) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var rootGetters, rootState, id, shopId, _rootState$queryMirro, from, to, userRes;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rootGetters = _ref6.rootGetters, rootState = _ref6.rootState;
              id = _ref7.id;
              shopId = rootGetters['queryMirrored/getOneDep'];
              _rootState$queryMirro = rootState.queryMirrored, from = _rootState$queryMirro.from, to = _rootState$queryMirro.to;
              _context2.next = 6;
              return API_REQUEST('getEmployees', {
                id__in: id,
                other_deps_employees_with_wd_in_curr_shop: true,
                include_employments: true,
                show_constraints: true,
                shop_id: shopId,
                employments__dt_from: from,
                employments__dt_to: to
              });

            case 6:
              userRes = _context2.sent;
              return _context2.abrupt("return", userRes[1] ? userRes[1][0] : {});

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  saveUserInfo: function saveUserInfo(_ref8, _ref9) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, newUserInfo, res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref8.commit;
              newUserInfo = _ref9.newUserInfo;
              _context3.next = 4;
              return API_REQUEST('updateUser', newUserInfo);

            case 4:
              res = _context3.sent;
              commit('setUserInfo', {
                id: newUserInfo.user_id,
                userInfo: newUserInfo
              });
              return _context3.abrupt("return", res[1] ? res[1] : null);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  saveUserTabelCode: function saveUserTabelCode(_ref10, newTabelCode) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref10.commit;
              _context4.next = 3;
              return API_REQUEST('updateEmployee', newTabelCode);

            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", res[1] ? res[1] : null);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  updatePassword: function updatePassword(context, _ref11) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var userId, confirmationPassword, newPassword, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              userId = _ref11.userId, confirmationPassword = _ref11.confirmationPassword, newPassword = _ref11.newPassword;
              _context5.next = 3;
              return API_REQUEST('changeUserPassword', {
                'id': userId,
                'new_password1': newPassword,
                'new_password2': newPassword,
                'confirmation_password': confirmationPassword
              }, true);

            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * @deprecated
   */
  saveEmployment: function saveEmployment(_ref12, _ref13) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _employmentRes$;

      var commit, employment, res, employmentRes, answer, workTypesById, _i, _Object$keys, workTypeId, workType, _answer, _answer2, _answer3;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref12.commit;
              employment = _ref13.employment;
              res = {};

              if (!employment['_main_changed']) {
                _context6.next = 25;
                break;
              }

              if (!employment['_isNew']) {
                _context6.next = 21;
                break;
              }

              _context6.next = 7;
              return API_REQUEST('createEmployment', employment);

            case 7:
              employmentRes = _context6.sent;

              if (!employmentRes[0]) {
                _context6.next = 12;
                break;
              }

              res['error'] = true;
              _context6.next = 19;
              break;

            case 12:
              if (!employmentRes[1]) {
                _context6.next = 19;
                break;
              }

              if (!employmentRes[1]['id']) {
                _context6.next = 17;
                break;
              }

              res['newEmploymentId'] = employmentRes[1]['id'];
              _context6.next = 19;
              break;

            case 17:
              document.dispatchEvent(new CustomEvent('apiRequestError', {
                detail: {
                  error: 'Трудоустройство не создано (id)'
                }
              }));
              return _context6.abrupt("return");

            case 19:
              _context6.next = 25;
              break;

            case 21:
              _context6.next = 23;
              return API_REQUEST('updateEmployment', employment);

            case 23:
              employmentRes = _context6.sent;
              if (employmentRes[0]) res['error'] = true;

            case 25:
              if (!(employment['_worker_constraints_changed'] && !res.error)) {
                _context6.next = 30;
                break;
              }

              _context6.next = 28;
              return API_REQUEST('saveEmploymentConstraints', {
                id: employment['id'] || res['newEmploymentId'],
                data: employment['_worker_constraints']
              });

            case 28:
              answer = _context6.sent;
              if (answer[0]) res['error'] = true;

            case 30:
              workTypesById = deepClone(employment._work_types_by_id);

              if (employmentRes && (_employmentRes$ = employmentRes[1]) !== null && _employmentRes$ !== void 0 && _employmentRes$.work_types) {
                employmentRes[1].work_types.forEach(function (workType) {
                  if (workTypesById[workType.work_type_id]) {
                    delete workTypesById[workType.work_type_id];
                  }
                });
              }

              if (!employment['_work_type_changed']) {
                _context6.next = 60;
                break;
              }

              _i = 0, _Object$keys = Object.keys(workTypesById);

            case 34:
              if (!(_i < _Object$keys.length)) {
                _context6.next = 60;
                break;
              }

              workTypeId = _Object$keys[_i];
              workType = workTypesById[workTypeId];

              if (!(workType.state === null)) {
                _context6.next = 46;
                break;
              }

              if (!workType.absId) {
                _context6.next = 44;
                break;
              }

              _context6.next = 41;
              return API_REQUEST('deleteEmploymentWorktype', {
                id: workType.absId
              });

            case 41:
              _answer = _context6.sent;
              if (_answer[0]) res['error'] = true;
              employment['_work_types_by_id'][workTypeId].absId = null;

            case 44:
              _context6.next = 57;
              break;

            case 46:
              if (!workType.absId) {
                _context6.next = 53;
                break;
              }

              _context6.next = 49;
              return API_REQUEST('updateEmploymentWorktype', {
                'id': workType.absId,
                'priority': workType.state,
                'work_type_id': workTypeId,
                'employment_id': employment['id']
              });

            case 49:
              _answer2 = _context6.sent;
              if (_answer2[0]) res['error'] = true;
              _context6.next = 57;
              break;

            case 53:
              _context6.next = 55;
              return API_REQUEST('createEmploymentWorktype', {
                'priority': workType.state,
                'work_type_id': workTypeId,
                'employment_id': employment['id'] || res['newEmploymentId']
              });

            case 55:
              _answer3 = _context6.sent;

              if (_answer3[0]) {
                res['error'] = true;
              } else {
                if (!res['newWorkerWorkTypeIds']) res['newWorkerWorkTypeIds'] = {};
                res['newWorkerWorkTypeIds'][workTypeId] = _answer3[1]['id'];
              }

            case 57:
              _i++;
              _context6.next = 34;
              break;

            case 60:
              return _context6.abrupt("return", res);

            case 61:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  saveEmployments: function saveEmployments(_ref14, _ref15) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var commit, employment, res, mainInfoRes, _res$employmentRes, constraintsRes, workTypesById;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref14.commit;
              employment = _ref15.employment;
              res = {};

              if (!employment._main_changed) {
                _context7.next = 9;
                break;
              }

              _context7.next = 6;
              return saveEmploymentMainInfo(employment);

            case 6:
              mainInfoRes = _context7.sent;
              res = mainInfoRes.overallResult;
              res.employmentRes = mainInfoRes.employmentRes;

            case 9:
              if (!employment._worker_constraints_changed) {
                _context7.next = 14;
                break;
              }

              _context7.next = 12;
              return saveEmploymentConstraints(employment, res.newEmploymentId || ((_res$employmentRes = res.employmentRes) === null || _res$employmentRes === void 0 ? void 0 : _res$employmentRes.id));

            case 12:
              constraintsRes = _context7.sent;
              res = _objectSpread(_objectSpread({}, res), constraintsRes);

            case 14:
              workTypesById = deepClone(employment._work_types_by_id);

              if (!employment._work_type_changed) {
                _context7.next = 18;
                break;
              }

              _context7.next = 18;
              return saveWorkTypesForEmployment(employment, workTypesById, res);

            case 18:
              return _context7.abrupt("return", res);

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  updateUsers: function updateUsers(_ref16, _ref17) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var rootState, dispatch, commit, pageNum, limit, lastName, userName, groupList, workTypesList, tabelCode, depIds, offset, usersRes, users, employments, emplByUserId, newUsers;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              rootState = _ref16.rootState, dispatch = _ref16.dispatch, commit = _ref16.commit;
              pageNum = _ref17.pageNum, limit = _ref17.limit, lastName = _ref17.lastName, userName = _ref17.userName, groupList = _ref17.groupList, workTypesList = _ref17.workTypesList, tabelCode = _ref17.tabelCode;
              depIds = rootState.queryMirrored.deps;
              offset = (pageNum - 1) * limit;
              _context8.next = 6;
              return API_REQUEST('getEmployees', {
                'shop_id__in': depIds,
                'last_name': lastName,
                'username': userName,
                'group_id__in': groupList,
                'work_type_id__in': workTypesList,
                'tabel_code': tabelCode,
                'offset': offset,
                'limit': limit,
                include_employments: true
              });

            case 6:
              usersRes = _context8.sent;
              users = usersRes[1].results;
              employments = users.map(function (user) {
                return user.employments;
              }).flat().filter(function (empl) {
                return empl.is_active;
              });

              if (!users.length) {
                _context8.next = 17;
                break;
              }

              _context8.next = 12;
              return dispatch('getEmploymentsForUsers', employments);

            case 12:
              emplByUserId = _context8.sent;
              newUsers = users.map(function (user) {
                var newUser = user.user;
                newUser['employee_id'] = user.id;
                newUser['user_id'] = user.user.id;
                newUser.checked = false;
                newUser.tabel_code = user.tabel_code;
                newUser.employments = emplByUserId[user.id];
                if (!newUser['employments']) newUser['employments'] = [];
                if (!newUser['worker_constraints']) newUser['worker_constraints'] = [];
                delete newUser.id;
                return newUser;
              });
              commit('setUsers', {
                users: newUsers
              });
              _context8.next = 18;
              break;

            case 17:
              commit('setUsers', {
                users: []
              });

            case 18:
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              return _context8.abrupt("return", {
                count: usersRes[1].count
              });

            case 20:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  fetchShiftSchedule: function fetchShiftSchedule(_ref18, _ref19) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var commit, state, employeeId, dateStart, dateEnd, _ref19$force, force, key, payload, _yield$API_REQUEST, _yield$API_REQUEST2, err, result, newValue;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref18.commit, state = _ref18.state;
              employeeId = _ref19.employeeId, dateStart = _ref19.dateStart, dateEnd = _ref19.dateEnd, _ref19$force = _ref19.force, force = _ref19$force === void 0 ? false : _ref19$force;
              _context9.prev = 2;

              if (employeeId) {
                _context9.next = 5;
                break;
              }

              throw new Error('Invalid login data');

            case 5:
              key = "".concat(employeeId, "-").concat(dateStart, "-").concat(dateEnd);

              if (!(state.fetchedShifts[key] && !force)) {
                _context9.next = 8;
                break;
              }

              return _context9.abrupt("return");

            case 8:
              payload = {
                dt__gte: dateStart,
                dt__lte: dateEnd,
                employee_id: employeeId
              };
              _context9.next = 11;
              return API_REQUEST('getEmployeeShiftSchedule', payload);

            case 11:
              _yield$API_REQUEST = _context9.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              err = _yield$API_REQUEST2[0];
              result = _yield$API_REQUEST2[1];

              if (!(err || result === false)) {
                _context9.next = 17;
                break;
              }

              throw err || new Error('Failed to fetch shiftSchedule');

            case 17:
              newValue = JSON.parse(JSON.stringify(state.shiftSchedule));

              if (result[employeeId]) {
                Object.keys(result[employeeId]).forEach(function (date) {
                  if (!newValue[employeeId]) {
                    newValue[employeeId] = {};
                  }

                  newValue[employeeId][date] = result[employeeId][date];
                });
              }

              commit('setShiftSchedule', newValue);
              commit('addFetchedShift', {
                employeeId: employeeId,
                dateStart: dateStart,
                dateEnd: dateEnd
              });
              _context9.next = 26;
              break;

            case 23:
              _context9.prev = 23;
              _context9.t0 = _context9["catch"](2);
              console.error(_context9.t0);

            case 26:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 23]]);
    }))();
  },
  addEmployments: function addEmployments(_ref20, items) {
    var commit = _ref20.commit,
        getters = _ref20.getters,
        vuexState = _ref20.state;
    var depsById = getters.departmentsIndexed;
    var positions = vuexState.positions;
    var employments = items.map(function (employment) {
      return formEmployment({
        employment: employment,
        depsById: depsById,
        workTypesById: getIndexedCollection(getters.workTypeByDepartmentId[employment.shop_id], 'id'),
        workTypes: getters.workTypeByDepartmentId[employment.shop_id],
        positions: positions
      });
    });
    commit('addEmployments', {
      items: employments,
      uniqueKey: 'id',
      isForce: true
    });
  },
  fetchEmploymentsForUsers: function fetchEmploymentsForUsers(_ref21, _ref22) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var dispatch, getters, state, employeeId, _ref22$isForce, isForce, employee;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dispatch = _ref21.dispatch, getters = _ref21.getters, state = _ref21.state;
              employeeId = _ref22.employeeId, _ref22$isForce = _ref22.isForce, isForce = _ref22$isForce === void 0 ? false : _ref22$isForce;
              _context10.next = 4;
              return dispatch('getEmployees', {
                employeeId: employeeId,
                isForce: isForce
              });

            case 4:
              employee = getters.employeesIndexed[employeeId];

              if (!(!employee || !employee.employments)) {
                _context10.next = 7;
                break;
              }

              return _context10.abrupt("return");

            case 7:
              dispatch('addEmployments', employee.employments);

            case 8:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  getEmployees: function getEmployees(_ref23, _ref24) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var commit, getters, rootGetters, rootState, employeeId, _ref24$isForce, isForce, _API_REQUEST, idKey, _yield$API_REQUEST3, _yield$API_REQUEST4, error, result;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref23.commit, getters = _ref23.getters, rootGetters = _ref23.rootGetters, rootState = _ref23.rootState;
              employeeId = _ref24.employeeId, _ref24$isForce = _ref24.isForce, isForce = _ref24$isForce === void 0 ? false : _ref24$isForce;
              _context11.prev = 2;

              if (!(getters.employeesIndexed[employeeId] && !isForce)) {
                _context11.next = 5;
                break;
              }

              return _context11.abrupt("return");

            case 5:
              idKey = typeof employeeId === 'string' ? 'id__in' : 'id';
              _context11.next = 8;
              return API_REQUEST('getEmployees', (_API_REQUEST = {}, _defineProperty(_API_REQUEST, idKey, employeeId), _defineProperty(_API_REQUEST, "include_employments", true), _defineProperty(_API_REQUEST, "show_constraints", true), _defineProperty(_API_REQUEST, "other_deps_employees_with_wd_in_curr_shop", true), _API_REQUEST));

            case 8:
              _yield$API_REQUEST3 = _context11.sent;
              _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
              error = _yield$API_REQUEST4[0];
              result = _yield$API_REQUEST4[1];

              if (!error) {
                _context11.next = 14;
                break;
              }

              throw error;

            case 14:
              commit('addEmployees', {
                items: _toConsumableArray(result),
                uniqueKey: 'id',
                isForce: true
              });
              _context11.next = 20;
              break;

            case 17:
              _context11.prev = 17;
              _context11.t0 = _context11["catch"](2);
              console.error(_context11.t0);

            case 20:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 17]]);
    }))();
  },
  fetchDepartments: function fetchDepartments(_ref25) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var commit, state, rootState, _ref26, _ref26$isForce, isForce, includeClients, includeOutsources, err1, err2, _yield$API_REQUEST5, _yield$API_REQUEST6, _yield$API_REQUEST7, _yield$API_REQUEST8, _yield$API_REQUEST9, _yield$API_REQUEST10, err3, includePossibleClients, allDepartments;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit = _ref25.commit, state = _ref25.state, rootState = _ref25.rootState;
              _ref26 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {
                isForce: false
              }, _ref26$isForce = _ref26.isForce, isForce = _ref26$isForce === void 0 ? false : _ref26$isForce;

              if (!(state.departments.length && !isForce)) {
                _context12.next = 4;
                break;
              }

              return _context12.abrupt("return");

            case 4:
              _context12.prev = 4;
              includeClients = rootState.cachedData.allDepsIncludeClients;
              includeOutsources = rootState.cachedData.allDepsIncludeOutsource;
              err2 = null;

              if (includeClients.length) {
                _context12.next = 15;
                break;
              }

              _context12.next = 11;
              return API_REQUEST('getAllDepartments', {
                include_clients: true
              });

            case 11:
              _yield$API_REQUEST5 = _context12.sent;
              _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 2);
              err1 = _yield$API_REQUEST6[0];
              includeClients = _yield$API_REQUEST6[1];

            case 15:
              if (includeOutsources.length) {
                _context12.next = 22;
                break;
              }

              _context12.next = 18;
              return API_REQUEST('getAllDepartments', {
                include_outsources: true
              });

            case 18:
              _yield$API_REQUEST7 = _context12.sent;
              _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 2);
              err2 = _yield$API_REQUEST8[0];
              includeOutsources = _yield$API_REQUEST8[1];

            case 22:
              _context12.next = 24;
              return API_REQUEST('getAllDepartments');

            case 24:
              _yield$API_REQUEST9 = _context12.sent;
              _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 2);
              err3 = _yield$API_REQUEST10[0];
              includePossibleClients = _yield$API_REQUEST10[1];

              if (!(err1 || err2 || err3)) {
                _context12.next = 30;
                break;
              }

              throw err1 || err2 || err3;

            case 30:
              allDepartments = filterByUniqueField([].concat(_toConsumableArray(includeClients), _toConsumableArray(includeOutsources), _toConsumableArray(includePossibleClients)), 'id');
              commit('setDepartments', {
                items: allDepartments
              });
              commit('setDepartmentsIncludeClients', {
                items: includeClients
              });
              commit('setDepartmentsIncludeOutsources', {
                items: includeOutsources
              });
              commit('setDepartmentsIncludePossibleClients', {
                items: includePossibleClients
              });
              _context12.next = 40;
              break;

            case 37:
              _context12.prev = 37;
              _context12.t0 = _context12["catch"](4);
              console.error(_context12.t0);

            case 40:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[4, 37]]);
    }))();
  },
  fetchWorkTypes: function fetchWorkTypes(_ref27) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var commit, state, rootGetters, getters, dispatch, _ref28, byDepId, _ref28$isForce, isForce, depIds, params, _yield$API_REQUEST11, _yield$API_REQUEST12, error, result, allWorkTypes;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit = _ref27.commit, state = _ref27.state, rootGetters = _ref27.rootGetters, getters = _ref27.getters, dispatch = _ref27.dispatch;
              _ref28 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {
                isForce: false
              }, byDepId = _ref28.byDepId, _ref28$isForce = _ref28.isForce, isForce = _ref28$isForce === void 0 ? false : _ref28$isForce;

              if (!(state.workTypes.length && !isForce)) {
                _context13.next = 4;
                break;
              }

              return _context13.abrupt("return");

            case 4:
              _context13.prev = 4;
              depIds = !byDepId ? rootGetters['queryMirrored/getDeps'] : _toConsumableArray(byDepId);
              params = byDepId === 'all' ? {} : {
                'shop_id__in': depIds
              };
              _context13.next = 9;
              return API_REQUEST('getWorkTypes', params);

            case 9:
              _yield$API_REQUEST11 = _context13.sent;
              _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 2);
              error = _yield$API_REQUEST12[0];
              result = _yield$API_REQUEST12[1];

              if (!error) {
                _context13.next = 15;
                break;
              }

              throw error;

            case 15:
              if (!(Object.keys(rootGetters['timetable/workTypeNamesIndexed']).length === 0)) {
                _context13.next = 18;
                break;
              }

              _context13.next = 18;
              return dispatch('timetable/fetchWorkTypeNames', {}, {
                root: true
              });

            case 18:
              allWorkTypes = formWorkTypesFromRequest(result, rootGetters['timetable/workTypeNamesIndexed']);
              commit('setWorkTypes', {
                items: allWorkTypes
              });
              _context13.next = 25;
              break;

            case 22:
              _context13.prev = 22;
              _context13.t0 = _context13["catch"](4);
              console.error(_context13.t0);

            case 25:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[4, 22]]);
    }))();
  },
  fetchPositions: function fetchPositions(_ref29) {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var commit, state, _ref30, _ref30$isForce, isForce, _yield$API_REQUEST13, _yield$API_REQUEST14, error, positions;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              commit = _ref29.commit, state = _ref29.state;
              _ref30 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {
                isForce: false
              }, _ref30$isForce = _ref30.isForce, isForce = _ref30$isForce === void 0 ? false : _ref30$isForce;

              if (!(state.positions.length && !isForce)) {
                _context14.next = 4;
                break;
              }

              return _context14.abrupt("return");

            case 4:
              _context14.prev = 4;
              _context14.next = 7;
              return API_REQUEST('getAllWorkerPositions', {
                include_outsources: true,
                include_clients: true,
                include_allowed_sawh_settings: true
              });

            case 7:
              _yield$API_REQUEST13 = _context14.sent;
              _yield$API_REQUEST14 = _slicedToArray(_yield$API_REQUEST13, 2);
              error = _yield$API_REQUEST14[0];
              positions = _yield$API_REQUEST14[1];

              if (!error) {
                _context14.next = 13;
                break;
              }

              throw error;

            case 13:
              commit('setPositions', {
                items: positions
              });
              _context14.next = 19;
              break;

            case 16:
              _context14.prev = 16;
              _context14.t0 = _context14["catch"](4);
              console.error(_context14.t0);

            case 19:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[4, 16]]);
    }))();
  },
  fetchNetworks: function fetchNetworks(_ref31) {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var commit, state, _ref32, _ref32$isForce, isForce, _yield$API_REQUEST15, _yield$API_REQUEST16, error, networks;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              commit = _ref31.commit, state = _ref31.state;
              _ref32 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {
                isForce: false
              }, _ref32$isForce = _ref32.isForce, isForce = _ref32$isForce === void 0 ? false : _ref32$isForce;

              if (!(state.networks.length && !isForce)) {
                _context15.next = 4;
                break;
              }

              return _context15.abrupt("return");

            case 4:
              _context15.prev = 4;
              _context15.next = 7;
              return API_REQUEST('getNetworks');

            case 7:
              _yield$API_REQUEST15 = _context15.sent;
              _yield$API_REQUEST16 = _slicedToArray(_yield$API_REQUEST15, 2);
              error = _yield$API_REQUEST16[0];
              networks = _yield$API_REQUEST16[1];

              if (!error) {
                _context15.next = 13;
                break;
              }

              throw error;

            case 13:
              commit('setNetworks', {
                items: networks
              });
              _context15.next = 19;
              break;

            case 16:
              _context15.prev = 16;
              _context15.t0 = _context15["catch"](4);
              console.error(_context15.t0);

            case 19:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[4, 16]]);
    }))();
  },

  /**
   * @param {import('./staff').StaffStore} VuexStore
   * @param {object=} payload
   * @param {boolean=} payload.isForce
   */
  fetchMedicalDocumentTypes: function fetchMedicalDocumentTypes(_ref33) {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var commit, state, _ref34, _ref34$isForce, isForce, _yield$API_REQUEST17, _yield$API_REQUEST18, error, medicalDocumentTypes;

      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              commit = _ref33.commit, state = _ref33.state;
              _ref34 = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {
                isForce: false
              }, _ref34$isForce = _ref34.isForce, isForce = _ref34$isForce === void 0 ? false : _ref34$isForce;

              if (!(state.medicalDocumentTypes.length && !isForce)) {
                _context16.next = 4;
                break;
              }

              return _context16.abrupt("return");

            case 4:
              _context16.prev = 4;
              _context16.next = 7;
              return API_REQUEST('getMedicalDocumentTypes');

            case 7:
              _yield$API_REQUEST17 = _context16.sent;
              _yield$API_REQUEST18 = _slicedToArray(_yield$API_REQUEST17, 2);
              error = _yield$API_REQUEST18[0];
              medicalDocumentTypes = _yield$API_REQUEST18[1];

              if (!error) {
                _context16.next = 13;
                break;
              }

              throw error;

            case 13:
              commit('setMedicalDocumentTypes', {
                items: medicalDocumentTypes
              });
              _context16.next = 19;
              break;

            case 16:
              _context16.prev = 16;
              _context16.t0 = _context16["catch"](4);
              console.error(_context16.t0);

            case 19:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[4, 16]]);
    }))();
  },

  /**
   * @param {import('./staff').StaffStore} VuexStore
   * @param {object=} payload
   * @param {number=} payload.employeeId
   * @param {boolean=} payload.isForce
   */
  fetchMedicalDocuments: function fetchMedicalDocuments(_ref35) {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var commit, state, _ref36, employeeId, _ref36$isForce, isForce, _yield$API_REQUEST19, _yield$API_REQUEST20, error, medicalDocuments;

      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              commit = _ref35.commit, state = _ref35.state;
              _ref36 = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {
                isForce: false
              }, employeeId = _ref36.employeeId, _ref36$isForce = _ref36.isForce, isForce = _ref36$isForce === void 0 ? false : _ref36$isForce;

              if (!(state.medicalDocuments.filter(function (el) {
                return +el.employee_id === +employeeId;
              }).length && !isForce)) {
                _context17.next = 4;
                break;
              }

              return _context17.abrupt("return");

            case 4:
              _context17.prev = 4;
              _context17.next = 7;
              return API_REQUEST('getMedicalDocuments', {
                employee_id: employeeId
              });

            case 7:
              _yield$API_REQUEST19 = _context17.sent;
              _yield$API_REQUEST20 = _slicedToArray(_yield$API_REQUEST19, 2);
              error = _yield$API_REQUEST20[0];
              medicalDocuments = _yield$API_REQUEST20[1];

              if (!error) {
                _context17.next = 13;
                break;
              }

              throw error;

            case 13:
              commit('setMedicalDocuments', {
                items: [].concat(_toConsumableArray(state.medicalDocuments), _toConsumableArray(medicalDocuments))
              });
              _context17.next = 19;
              break;

            case 16:
              _context17.prev = 16;
              _context17.t0 = _context17["catch"](4);
              console.error(_context17.t0);

            case 19:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[4, 16]]);
    }))();
  },

  /**
   * @param {import('./staff').StaffStore} VuexStore
   * @param {object} payload
   * @param {number} payload.employeeId
   * @param {number} payload.medicalDocumentTypeId
   * @param {string} payload.dateFrom
   * @param {string} payload.dateTo
   */
  addMedicalDocuments: function addMedicalDocuments(_ref37, _ref38) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      var commit, employeeId, medicalDocumentTypeId, dateFrom, dateTo, requestPayload, _yield$API_REQUEST21, _yield$API_REQUEST22, error, medicalDocument;

      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              commit = _ref37.commit;
              employeeId = _ref38.employeeId, medicalDocumentTypeId = _ref38.medicalDocumentTypeId, dateFrom = _ref38.dateFrom, dateTo = _ref38.dateTo;
              requestPayload = {
                employee_id: employeeId,
                medical_document_type_id: medicalDocumentTypeId,
                dt_from: dateFrom,
                dt_to: dateTo
              };
              /** @type {[any, MedicalDocument]} */

              _context18.next = 5;
              return API_REQUEST('addMedicalDocument', requestPayload);

            case 5:
              _yield$API_REQUEST21 = _context18.sent;
              _yield$API_REQUEST22 = _slicedToArray(_yield$API_REQUEST21, 2);
              error = _yield$API_REQUEST22[0];
              medicalDocument = _yield$API_REQUEST22[1];

              if (!(error || !medicalDocument)) {
                _context18.next = 11;
                break;
              }

              throw error || new Error('Error adding new medical document');

            case 11:
              commit('addMedicalDocuments', {
                items: [medicalDocument],
                isForce: true
              });

            case 12:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }))();
  },

  /**
   * @param {import('./staff').StaffStore} VuexStore
   * @param {object} payload
   * @param {number} payload.id
   * @param {number=} payload.employeeId
   * @param {number=} payload.medicalDocumentTypeId
   * @param {string=} payload.dateFrom
   * @param {string=} payload.dateTo
   */
  updateMedicalDocuments: function updateMedicalDocuments(_ref39, _ref40) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var commit, id, employeeId, medicalDocumentTypeId, dateFrom, dateTo, requestPayload, _yield$API_REQUEST23, _yield$API_REQUEST24, error, medicalDocument;

      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              commit = _ref39.commit;
              id = _ref40.id, employeeId = _ref40.employeeId, medicalDocumentTypeId = _ref40.medicalDocumentTypeId, dateFrom = _ref40.dateFrom, dateTo = _ref40.dateTo;
              requestPayload = {
                id: id,
                employee_id: employeeId,
                medical_document_type_id: medicalDocumentTypeId,
                dt_from: dateFrom,
                dt_to: dateTo
              };
              /** @type {[any, MedicalDocument]} */

              _context19.next = 5;
              return API_REQUEST('updateMedicalDocument', requestPayload);

            case 5:
              _yield$API_REQUEST23 = _context19.sent;
              _yield$API_REQUEST24 = _slicedToArray(_yield$API_REQUEST23, 2);
              error = _yield$API_REQUEST24[0];
              medicalDocument = _yield$API_REQUEST24[1];

              if (!(error || !medicalDocument)) {
                _context19.next = 11;
                break;
              }

              throw error || new Error('Error updating medical document');

            case 11:
              commit('updateMedicalDocuments', {
                items: [medicalDocument]
              });

            case 12:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }))();
  },

  /**
   * @param {import('./staff').StaffStore} VuexStore
   * @param {object} payload
   * @param {number} payload.id
   */
  deleteMedicalDocuments: function deleteMedicalDocuments(_ref41, _ref42) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      var commit, getters, id, requestPayload, documentToDelete, _yield$API_REQUEST25, _yield$API_REQUEST26, error;

      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              commit = _ref41.commit, getters = _ref41.getters;
              id = _ref42.id;
              requestPayload = {
                id: id
              };
              documentToDelete = getters.medicalDocumentsIndexed[id];

              if (!documentToDelete) {
                Error("Medical document id: ".concat(id, " not found"));
              }
              /** @type {[any, MedicalDocument]} */


              _context20.next = 7;
              return API_REQUEST('deleteMedicalDocument', requestPayload);

            case 7:
              _yield$API_REQUEST25 = _context20.sent;
              _yield$API_REQUEST26 = _slicedToArray(_yield$API_REQUEST25, 1);
              error = _yield$API_REQUEST26[0];

              if (!error) {
                _context20.next = 12;
                break;
              }

              throw error;

            case 12:
              commit('deleteMedicalDocuments', {
                items: [documentToDelete]
              });

            case 13:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }))();
  }
};

var getters = _objectSpread(_objectSpread({}, getUniversalGetters(state())), {}, {
  employmentsByUserId: function employmentsByUserId(state) {
    var output = {};
    state.employments.forEach(function (employment) {
      if (!output[employment.user_id]) {
        output[employment.user_id] = [employment];
      } else {
        output[employment.user_id].push(employment);
      }
    });
    return output;
  },
  employmentsByEmployeeId: function employmentsByEmployeeId(state) {
    var output = {};
    state.employments.forEach(function (employment) {
      if (!output[employment.employee_id]) {
        output[employment.employee_id] = [employment];
      } else {
        output[employment.employee_id].push(employment);
      }
    });
    return output;
  },
  workTypeByDepartmentId: function workTypeByDepartmentId(state) {
    var departmentIds = lens(state.departments, 'id');
    return departmentIds.reduce(function (acc, departmentId) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, departmentId, state.workTypes.filter(function (el) {
        return el.shopId === departmentId;
      })));
    }, {});
  },
  employmentMainWorkType: function employmentMainWorkType(state, getters) {
    return function (id) {
      var _Object$entries$find, _Object$entries$find2;

      var employments = getters.employmentsByEmployeeId[id].filter(function (item) {
        return item.is_active;
      });
      if (!employments.length) return null;
      if (employments.length === 1) return Number((_Object$entries$find = Object.entries(employments[0]._work_types_by_id).find(function (_ref43) {
        var _ref44 = _slicedToArray(_ref43, 2),
            key = _ref44[0],
            val = _ref44[1];

        return val.state === 1;
      })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0]);
      var today = new Date();
      var actualEmployment = employments.sort(function (a, b) {
        return Math.abs(new Date(a.dt_hired) - today) - Math.abs(new Date(b.dt_hired) - today);
      })[0];
      return Number((_Object$entries$find2 = Object.entries(actualEmployment._work_types_by_id).find(function (_ref45) {
        var _ref46 = _slicedToArray(_ref45, 2),
            key = _ref46[0],
            val = _ref46[1];

        return val.state === 1;
      })) === null || _Object$entries$find2 === void 0 ? void 0 : _Object$entries$find2[0]);
    };
  },
  employmentMainWorkChosenDate: function employmentMainWorkChosenDate(state, getters) {
    return function (_ref47) {
      var _Object$entries$find3;

      var id = _ref47.id,
          date = _ref47.date,
          shopId = _ref47.shopId;
      var employments = getters.employmentsByEmployeeId[id];
      if (!employments.length) return null;
      var chosenDate = new Date(date);
      var employmentsList = employments.filter(function (item) {
        return String(item.shop_id) === String(shopId) && new Date(item.dt_hired) <= chosenDate && new Date(item.dt_fired) >= chosenDate;
      });
      if (!employmentsList.length) return null;
      return Number((_Object$entries$find3 = Object.entries(employments[0]._work_types_by_id).find(function (_ref48) {
        var _ref49 = _slicedToArray(_ref48, 2),
            key = _ref49[0],
            val = _ref49[1];

        return val.state === 1;
      })) === null || _Object$entries$find3 === void 0 ? void 0 : _Object$entries$find3[0]);
    };
  }
});

export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};